export default __webpack_public_path__ + "static/media/pte.f1256488.png";